import { color as themeColor } from '../../../app/theme';

function IconDatabase({ className, backgroundColor = themeColor.$23 }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.333 5.584c0-1.8 3.467-2.667 6.667-2.667 3.2 0 6.667.867 6.667 2.667v9.333c0 1.8-3.467 2.667-6.667 2.667-3.2 0-6.667-.867-6.667-2.667V5.584zm6.667 6c3.667 0 5.333-1 5.333-1.334v-3c-1.266.667-3.333 1-5.333 1s-4.067-.333-5.333-1v3c0 .334 1.666 1.334 5.333 1.334zm0-7.334c3.467 0 5.333 1 5.333 1.334 0 .333-1.866 1.333-5.333 1.333s-5.333-1-5.333-1.333C4.667 5.25 6.533 4.25 10 4.25zM4.667 14.917c0 .333 1.666 1.333 5.333 1.333 3.667 0 5.333-1 5.333-1.333v-3c-1.266.667-3.333 1-5.333 1s-4.067-.333-5.333-1v3z"
        fill={backgroundColor}
      />
    </svg>
  );
}

export default IconDatabase;
